const skills = [
  {
    id: 2,
    img: "https://i.ibb.co/JWX1681X/Conflict-Management-at-Workplace-at-Next-Sourcing.jpg",
    companyName: "Conflict Management Training at Next Sourcing",
  },

  {
    id: 4,
    img: "https://i.ibb.co/Qjv7gNWf/Effective-Leadership-Training-with-the-Top-Management-Team-of-Rancon-Group-batch-2.jpg",
    companyName:
      "Effective Leadership Training with the Top Management Team of Rancon Group-(Batch-2)",
  },
  {
    id: 5,
    img: "https://i.ibb.co/99MJYhX2/Effective-Leadership-Training-with-the-Top-Management-Team-of-Rancon-Group.jpg",
    companyName:
      "Effective Leadership Training with the Top Management Team of Rancon Group",
  },
  {
    id: 6,
    img: "https://i.ibb.co/CSfhsgX/Effective-Negotiation-Skill-Training-at-Suzuki-Bangladesh-Rancon-Motor-Bikes-Ltd.jpg",
    companyName:
      "Effective Negotiation Skill Training at Suzuki Bangladesh - Rancon Motor Bikes Ltd.",
  },
  {
    id: 3,
    img: "https://i.ibb.co/QjjCNmhZ/Conflict-Resolution-at-Workplace-training-at-Next-Sourcing.jpg",
    companyName: "Conflict Resolution training at Next Sourcing",
  },
  {
    id: 8,
    img: "https://i.ibb.co/mVKvMcQJ/Emotional-intelligence-Team-Building-with-the-Leadership-Training-with-the-Team-of-Confidence-Power.jpg",
    companyName:
      "Emotional intelligence & Team Building with the Leadership Training with the Team of Confidence Power Bogura Limited",
  },
  {
    id: 9,
    img: "https://i.ibb.co/4ZkzNkkx/Executive-Presence-training-at-ACI-Godrej-Agrovet-Private-Limited.jpg",
    companyName:
      "Executive Presence training at ACI Godrej Agrovet Private Limited.",
  },
  {
    id: 10,
    img: "https://i.ibb.co/fYB0hf9V/Executive-Presence-Training-at-MNC.jpg",
    companyName: "Executive Presence Training at ACI godrej LTD",
  },
  {
    id: 11,
    img: "https://i.ibb.co/7NSxSbjs/Habits-of-Highly-Effective-Leaders-at-The-ACME-Laboratories-Ltd-ACME-Batch-2.jpg",
    companyName:
      "Habits of Highly Effective Leaders at The ACME Laboratories Ltd.ACME- (Batch 2) ",
  },
  {
    id: 12,
    img: "https://i.ibb.co/DPbd8GDB/Habits-of-Highly-Effective-Leaders-2-at-The-ACME-Laboratories-Ltd-ACME.jpg",
    companyName:
      "Habits of Highly Effective Leaders at The ACME Laboratories Ltd.ACME",
  },
  {
    id: 13,
    img: "https://i.ibb.co/p6CpqTKr/Leadership-with-Lean-Thinking-at-li-fung.jpg",
    companyName: "Leadership with Lean Thinking at Li & Fung Bangladesh Ltd.",
  },
  {
    id: 14,
    img: "https://i.ibb.co/dTxG2rQ/Negotiation-Soft-Skill-Training-At-Apex-Footwear-Limited.jpg",
    companyName: "Negotiation Soft Skill Training At Apex Footwear Limited",
  },

  {
    id: 17,
    img: "https://i.ibb.co/zhyPgpfb/Personal-Productivity-training-at-Islami-Bank.jpg",
    companyName: "Personal Productivity training at Islami Bank",
  },
  {
    id: 18,
    img: "https://i.ibb.co/mF5NYX04/Positive-Mindset-and-Productivity-Improvement-Techniques-at-CCDB-Hope-Center-Savar.jpg",
    companyName:
      "Positive Mindset and Productivity Improvement Techniques at  CCDB Hope Center, Savar",
  },
  {
    id: 19,
    img: "https://i.ibb.co/67wHyRg5/Professional-Excellence-Training-at-Radiant-Pharmaceuticals-Limited-1.jpg",
    companyName:
      "Professional Excellence Training at Radiant Pharmaceuticals Limited",
  },
  {
    id: 7,
    img: "https://i.ibb.co/0RW0wL9G/Elevating-Leadership-at-ACI-Godrej-Agrovet-Private-Limited.jpg",
    companyName: "Elevating Leadership at ACI Godrej Agrovet Private Limited.",
  },
  {
    id: 12,
    img: "https://i.ibb.co/VW4D7FMq/Kaizen-Training-at-Bangladesh-Bank-BBTA.jpg",
    companyName: "Kaizen Training at Bangladesh Bank (BBTA)",
  },
  {
    id: 21,
    img: "https://i.ibb.co/35DL449y/Professional-Excellence-Training-at-Radient-Pharma-Radiant-Pharmaceuticals-Limited.jpg",
    companyName:
      "Professional Excellence Training at Radient Pharma  Radiant Pharmaceuticals Limited",
  },

  {
    id: 23,
    img: "https://i.ibb.co/5xh3hC5p/Professional-Excellence-Training-Radiant-Pharmaceuticals-Limited-3rd-Batch.jpg",
    companyName:
      "Professional Excellence Training Radiant Pharmaceuticals Limited (3rd Batch) ",
  },
  {
    id: 21,
    img: "https://i.ibb.co/tMcWG8p1/Training-for-the-Trainers-with-Essential-Drug-Compnay-Limited.jpg",
    companyName:
      "Training for the Trainers with Essential Drug Company Limited",
  },
  {
    id: 26,
    img: "https://i.ibb.co/xtWLKB4T/sales-team-effectiveness-persuasion-strategies-strengthen-communication-and-align-personal-growth-at.jpg",
    companyName:
      "sales team effectiveness, persuasion strategies, strengthen communication, and align personal growth at Eurofins",
  },
  {
    id: 27,
    img: "https://i.ibb.co/zTqWxnns/Self-and-People-Management-at-Intertek.jpg",
    companyName: "Self and People Management at  Intertek",
  },

  {
    id: 30,
    img: "https://i.ibb.co/zTGY1RFf/Stress-Management-Resilience-Building-at-GTL-Valuka-Mymensigh.jpg",
    companyName:
      "Stress Management & Resilience Building at GTL, Valuka, Mymensigh",
  },

  {
    id: 33,
    img: "https://i.ibb.co/0p2y3B7c/Team-Building-training-session-at-r-pac.jpg",
    companyName: "Team Building training session at r-pac",
  },
  {
    id: 34,
    img: "https://i.ibb.co/v0575cZ/team-building-session-with-the-amazing-mid-level-employees-of-r-pac.jpg",
    companyName:
      "team-building session with the amazing mid-level employees of r-pac",
  },
  {
    id: 35,
    img: "https://i.ibb.co/mVYLbWWt/Training-of-Trainers-TOT-with-Square-Pharmaceuticals-PLC.jpg",
    companyName: "Training of Trainers (TOT) with Square Pharmaceuticals PLC",
  },
  {
    id: 36,
    img: "https://i.ibb.co/TqMzYLdJ/Workplace-Efficiency-Productivity-ACI-Healthcare-Limited-and-ACI-Pharma-Health-Life.jpg",
    companyName:
      "Workplace Efficiency & Productivity  ACI Healthcare Limited and ACI Pharma - Health & Life",
  },
  {
    id: 37,
    img: "https://i.ibb.co/vCYGq0qb/Workplace-Efficiency-Productivity-at-ACI-Center.jpg",
    companyName: "Workplace Efficiency & Productivity at ACI Center",
  },
  {
    id: 38,
    img: "https://i.ibb.co/GrcgQ9f/Effective-Communication-Skill-at-Gemcon-Group.jpg",
    companyName: "Effective Communication Skill at Gemcon Group",
  },
  {
    id: 39,
    img: "https://i.ibb.co/mVfP6w1f/Leadership-and-Supervisory-Skill-Development-at-Graphic-Textiles-Ltd.jpg",
    companyName:
      "Leadership and Supervisory Skill Development at Graphic Textiles Ltd",
  },
  {
    id: 30,
    img: "https://i.ibb.co/ZRbBDqRx/People-Handling-Skill-with-seafarers-mostly-Master-Captains-Chief-Engineer-at-K-line.jpg",
    companyName:
      "People Handling Skill with seafarers, mostly Master Captains, Chief Engineer at K line",
  },
  {
    id: 31,
    img: "https://i.ibb.co/2fXkxQp/Proactive-Leadership-with-Continuous-Improvement-Thinking-Consulting-at-CP-Bangladesh.jpg",
    companyName:
      "Proactive Leadership with Continuous Improvement Thinking Training at CP Bangladesh",
  },
  {
    id: 10,
    img: "https://i.ibb.co/SXm4szfB/Habits-That-Totally-Transform-Your-Productivity-training-at-ULAB.jpg",
    companyName:
      "Habits That Totally Transform Your Productivity training at ULAB",
  },
  {
    id: 11,
    img: "https://i.ibb.co/ycfLmWb0/Be-the-Best-Version-of-Yourself-Make-Rest-of-Your-Life-the-Best-of-Your-Life-at-East-West-University.jpg",
    companyName:
      "Be the Best Version of Yourself “ & “Make Rest of Your Life the Best of Your Life” at East West University",
  },
  {
    id: 13,
    img: "https://i.ibb.co/BKrYYS6G/Lean-Six-Sigma-Training-at-East-West-University.jpg",
    companyName: "Training at East West University",
  },
  {
    id: 14,
    img: "https://i.ibb.co/ymGdvBD8/Personal-Excellence-Training-at-Santo-Mariam-University-Dhak.jpg",
    companyName:
      "Personal Excellence Training at Santo Mariam University, Dhaka",
  },
  {
    id: 15,
    img: "https://i.ibb.co/WWKFFZ20/Reprogramming-of-Subconscious-Mind-for-Success-Training-at-East-West-University.jpg",
    companyName:
      "Reprogramming of Subconscious Mind for Success Training at East West University",
  },
  {
    id: 16,
    img: "https://i.ibb.co/4wMGrhDs/Stress-Management-Training-at-EGMCL-EPIC-Group.jpg",
    companyName: "Stress Management Training at EGMCL- EPIC Group",
  },
  {
    id: 17,
    img: "https://i.ibb.co/Psn3PXnB/Branch-Excellence-Training-at-Sajida-Foundation.jpg",
    companyName: "Branch Excellence Training at Sajida Foundation",
  },
  {
    id: 18,
    img: "https://i.ibb.co/KQD8LBq/Personal-Excellent-at-Shanta-Industries-DEWHIRST.jpg",
    companyName: "Personal Excellence at Shanta Industries- DEWHIRST",
  },
  {
    id: 19,
    img: "https://i.ibb.co/mFbRQXnF/Leadership-Training-at-Asian-Group-Chittagong.jpg",
    companyName: "Leadership Training at Asian Group Chittagong",
  },
  {
    id: 20,
    img: "https://i.ibb.co/27jPBrKx/Training-at-Ejab-Group.jpg",
    companyName: "Training at Ejab Group",
  },
  {
    id: 21,
    img: "https://i.ibb.co/DgPyzysG/Leadership-Training-at-Bangla-CAT.jpg",
    companyName: "Leadership Training at BanglaCAT",
  },
  {
    id: 22,
    img: "https://i.ibb.co/4wgPrHXw/Soft-Skill-Training-at-United-Commercial-Bank.jpg",
    companyName: "Soft Skill Training at United Commercial Bank",
  },
  {
    id: 23,
    img: "https://i.ibb.co/RpvHGg7t/Leadership-Training-with-GEO-Steel.jpg",
    companyName: "Leadership Training with GEO Steel",
  },
  {
    id: 24,
    img: "https://i.ibb.co/sdDK83L4/Time-Management-with-Islami-Bank.jpg",
    companyName: "Time Management with Islami Bank",
  },
  {
    id: 25,
    img: "https://i.ibb.co/j9WZPTSg/Training-at-Partex-Group.jpg",
    companyName: "Training at Partex Group",
  },
  {
    id: 26,
    img: "https://i.ibb.co/pvj8my7S/Training-on-Habit-Transformation-with-JCI.jpg",
    companyName: "Training on Habit Transformation with JCI",
  },
  // {
  //   id: 38,
  //   img: "https://i.ibb.co/hRfVBQdz/s-01.jpg",
  // },
  // {
  //   id: 39,
  //   img: "https://i.ibb.co/9QTXYt7/s-s-1-28.jpg",
  // },
  // {
  //   id: 40,
  //   img: "https://i.ibb.co/27DvH0HT/s-s-1-29.jpg",
  // },
  // {
  //   id: 41,
  //   img: "https://i.ibb.co/spyv0LKT/s-s-1-30.jpg",
  // },
  // {
  //   id: 42,
  //   img: "https://i.ibb.co/Y7sC1x20/s-s-1-31.jpg",
  // },
  // {
  //   id: 43,
  //   img: "https://i.ibb.co/qLGTwnhr/s-s-1-32.jpg",
  // },
  // {
  //   id: 44,
  //   img: "https://i.ibb.co/rRV9Xxhs/s-s-1-33.jpg",
  // },
  // {
  //   id: 45,
  //   img: "https://i.ibb.co/qM4KKwDT/s-s-1-34.jpg",
  // },
  // {
  //   id: 46,
  //   img: "https://i.ibb.co/QFXmD9D2/s-s-1-35.jpg",
  // },
  // {
  //   id: 47,
  //   img: "https://i.ibb.co/Ld9QTJw7/s-s-1-36.jpg",
  // },
  // {
  //   id: 48,
  //   img: "https://i.ibb.co/rKp3C8XF/s-02.jpg",
  // },
];

export default skills;
